import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listDealerUserOrganization, bindOrganization } from '@/api/organization.js';
import { sendCode as _sendCode, updatePassword } from '@/api/global.js';
import { clearMenu } from '@/menu';
import { mapState, mapActions } from 'vuex';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
export default {
  components: {},
  data: function data() {
    var _this = this;

    var passwordValidator = function passwordValidator(rule, value, callback) {
      var reg = new RegExp('^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,32})$');

      if (!reg.test(value)) {
        return callback(new Error('密码必须同时包含字母和数字'));
      }

      if (value.length < 8 || value.length > 20) {
        return callback(new Error('密码长度限8-20位'));
      }

      if (_this.passwordForm.newPassword !== _this.passwordForm.newPassword2) {
        return callback(new Error('确认新密码与新密码必须一致'));
      } else {
        callback();
      }
    };

    return {
      profile: {
        nickName: '周洪利',
        mobile: '',
        organizationName: '测试组织'
      },
      dialogVisible: false,
      passwordDialogVisible: false,
      passwordForm: {
        newPassword: '',
        newPassword2: '',
        code: ''
      },
      passwordFormRules: {
        newPassword: [{
          required: true,
          message: '请输入新密码',
          trigger: 'blur'
        }, {
          validator: passwordValidator
        }],
        newPassword2: [{
          required: true,
          message: '请输入确认新密码',
          trigger: 'blur'
        }, {
          validator: passwordValidator
        }],
        code: [{
          required: true,
          message: '请输入短信码',
          trigger: 'blur'
        }]
      },
      codeTimer: 0,
      organizationList: []
    };
  },
  computed: _objectSpread({}, mapState('d2admin/user', ['info'])),
  mounted: function mounted() {
    if (!this.info.name) {
      this.logout();
    } else {
      this.loadProfile();
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    loadProfile: function loadProfile() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var db;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.database({
                  user: true
                });

              case 2:
                db = _context.sent;

                if (_this2.profile) {
                  _this2.profile = db.get('profile').value();
                }

                console.log(_this2.profile);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    },
    switchOrganization: function switchOrganization() {
      var that = this;
      listDealerUserOrganization().then(function (res) {
        that.organizationList = res.list;
        that.dialogVisible = true;
      });
    },
    organizationClick: function organizationClick(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, db, profile;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this3;
                _context4.next = 3;
                return _this3.database({
                  user: true
                });

              case 3:
                db = _context4.sent;
                profile = db.get('profile').value();
                clearMenu();
                that.organizationId = e.id;
                bindOrganization({
                  organization_id: that.organizationId,
                  role_type: 0
                }).then( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            listDealerUserManufacturer().then( /*#__PURE__*/function () {
                              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res2) {
                                var findRow;
                                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        if (!(res2.list.length === 0)) {
                                          _context2.next = 5;
                                          break;
                                        }

                                        that.$message.error('该组织未绑定经销商');
                                        bindOrganization({
                                          organization_id: profile.organizationId,
                                          role_type: 0
                                        });
                                        _context2.next = 22;
                                        break;

                                      case 5:
                                        findRow = res2.list.find(function (item) {
                                          return item.show_status === true && (item.examine_status === 0 || item.examine_status === 3);
                                        });

                                        if (!findRow) {
                                          _context2.next = 20;
                                          break;
                                        }

                                        profile.organizationId = res.organizationId;
                                        profile.organizationName = res.organizationName;
                                        db.set('profile', profile).write();
                                        that.profile = profile;
                                        that.$router.push('/index');
                                        that.$emit('menuClose'); // that.$store.dispatch('d2admin/user/set', { name: res.name }, { root: true })

                                        _context2.next = 15;
                                        return that.$store.dispatch('d2admin/user/set', res, {
                                          root: true
                                        });

                                      case 15:
                                        that.$store.dispatch('d2admin/page/closeAll');
                                        that.dialogClose();
                                        that.$nextTick(function () {
                                          that.$router.replace('/refresh');
                                        });
                                        _context2.next = 22;
                                        break;

                                      case 20:
                                        that.$message.error('已绑定的经销商被禁用，无法登录');
                                        bindOrganization({
                                          organization_id: profile.organizationId,
                                          role_type: 0
                                        });

                                      case 22:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2);
                              }));

                              return function (_x2) {
                                return _ref2.apply(this, arguments);
                              };
                            }());

                          case 1:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (err) {// this.$message.error(err.message)
                });

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    changePassword: function changePassword() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that, db, profile;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this4;
                _context5.next = 3;
                return _this4.database({
                  user: true
                });

              case 3:
                db = _context5.sent;
                profile = db.get('profile').value();
                that.profile = profile;
                that.passwordDialogVisible = true;
                that.passwordForm = {
                  newPassword: '',
                  newPassword2: '',
                  code: ''
                };
                that.$nextTick(function () {
                  that.$refs.passwordForm.clearValidate();
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    sendCode: function sendCode() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, db, profile, form;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this5;

                if (!(that.codeTimer > 0)) {
                  _context6.next = 3;
                  break;
                }

                return _context6.abrupt("return");

              case 3:
                _context6.next = 5;
                return _this5.database({
                  user: true
                });

              case 5:
                db = _context6.sent;
                profile = db.get('profile').value();
                form = {
                  event: 'change_pass',
                  mobile: profile.mobile
                };

                _sendCode(form).then(function (res) {
                  that.$notify.success('发送成功');
                  that.codeTimer = 60;
                  that.sendCodeCD();
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    sendCodeCD: function sendCodeCD() {
      var that = this;

      if (that.codeTimer > 0) {
        that.codeTimer = that.codeTimer - 1;
        setTimeout(function () {
          that.sendCodeCD();
        }, 1000);
      }
    },
    passwordFormSubmit: function passwordFormSubmit() {
      var _this6 = this;

      var that = this;
      that.$refs.passwordForm.validate(function (valid, err) {
        if (valid) {
          var form = JSON.parse(JSON.stringify(that.passwordForm));
          updatePassword(form).then(function (res) {
            that.$notify.success('密码修改成功');
            that.passwordDialogClose();
          });
        } else {
          for (var item in err) {
            _this6.$message.error(err[item][0].message);

            return;
          }
        }
      });
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.dialogVisible = false;
    },
    passwordDialogClose: function passwordDialogClose() {
      var that = this;
      that.passwordDialogVisible = false;
    }
  })
};